<div class="sgt-plataforma-origem-badge">
    <!-- ERP -->
    <ng-template [ngIf]="config?.isOrigemERP">
        <sgt-plataforma-badge
            [logoURL]="logoURLErp"
            [logoURLWidth]="logoURLWidth"
            [isShowNome]="isShowNome"
            [nome]="nomeErp">
        </sgt-plataforma-badge>
    </ng-template>

    <!-- E-commerce -->
    <ng-template [ngIf]="config?.isOrigemEcommerce">
        <sgt-plataforma-badge
            [logoURL]="logoURLEcommerce"
            [logoURLWidth]="logoURLWidth"
            [isShowNome]="isShowNome"
            [nome]="nomeEcommerce">
        </sgt-plataforma-badge>
    </ng-template>
</div>  